module.exports = __webpack_public_path__ + "static/media/tum-urunler-2.e3ac9b5e.png";